import { render } from "./GeoAree.vue?vue&type=template&id=18950d5b"
import script from "./GeoAree.vue?vue&type=script&lang=js"
export * from "./GeoAree.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__